<template lang="pug">
  v-content
    v-toolbar(flat="" color="white")
      v-toolbar-title סנדי - מסכים
      v-divider.mx-2(inset="" vertical="")
      v-spacer
      v-dialog(v-model="dialog" max-width="800px").rtl
        v-btn.mb-2(slot="activator" color="primary" dark="") מסך חדש
        v-card
          v-card-title
            span.headline {{ formTitle }}
          v-card-text
            v-container(grid-list-md="").rtl
              v-layout(wrap="")
                v-flex(xs12)
                  v-text-field(reverse right v-model="editedItem.name" label="שם המסך")
                v-flex(xs12)
                  v-text-field(reverse right v-model="editedItem.sub_title" label="כותרת משנה")
                v-flex(xs12).ltr
                  v-textarea(solo v-model="editedItem.sql" label="SQL")
                v-flex(xs12).ltr
                  v-switch(v-model="editedItem.show_in_home_page" label="?להראות בדף הבית")

                //v-flex(xs6)
                //    v-select(reverse v-model="editedItem.range_excel_column_start" :items="range('A', 'Z')", label='הצג מעמודה')

                v-flex.pa-2(xs12).ltr
                  v-text-field(v-model="editedItem.screen_for_metadata" type="number" label="פתיחת מסך בלחיצה על שורה (במקרה של מילוי המערכת תחליף את הערך שבין שני __||__ בערך מהשורה שנלחצה)")
                v-flex.pa-2(xs12).ltr
                  v-text-field(v-model="editedItem.default_rows_number_to_show" label="מספר שורות שיוצגו בטבלה בדיפולט")
                v-flex.pa-2(xs12).ltr
                  v-text-field(v-model="editedItem.style.table_width_single" label="רוחב טבלה כשמוצגת טבלה אחת במסך, css format")
                v-layout(wrap)
                  v-flex(xs8)
                    v-text-field(reverse right v-model="editedItem.beep_field_name" label="שם השדה עבור השמעת צליל בטעינת מסך")
                  v-flex(xs4)
                    v-text-field(reverse right v-model="editedItem.beep_type_number" label="סוג הצליל" max=15 min=1 type="number")
              v-flex.pa-2(xs12).ltr
                v-text-field(type="number" v-model="editedItem.style.table_width_multi" label="*משקל יחסי* לטבלה זו, כשמוצגת יותר מטבלה אחת במסך")
              v-flex(xs12).ltr
                v-switch(v-model="editedItem.automatic_information_loading" label="?להציג מידע אוטומטית בטעינת המסך")
              v-flex.pa-2(xs12 style="border: solid 1px #aaa")
                h3  שדות חיפוש
                v-layout(wrap v-for="(w, index) in editedItem.meta.search_fields").mb-2.lighten-4.blue
                  v-flex(xs5)
                    v-text-field(reverse v-model="editedItem.meta.search_fields[index].column" :label="'עמודה '+(index + 1)")
                  v-flex(xs5)
                    v-text-field(reverse v-model="editedItem.meta.search_fields[index].placeholder" :label="'placeholder '+(index + 1)")
                  v-flex(xs2).text-xs-center.pa-4
                    v-tooltip(top)
                      v-icon(slot='activator' @click="editedItem.meta.search_fields.splice(index, 1)") delete
                      span מחק

                v-flex.pa-3(xs12).ltr
                  v-tooltip(top)
                    v-icon.ml-2(slot='activator' @click="editedItem.meta.search_fields.push({})") add
                    span  הוסף


          v-card-actions
            v-spacer
            v-btn(color="blue darken-1" flat="" @click="close") Cancel
            v-btn(color="blue darken-1" flat="" @click="save(editedItem)") Save
    v-data-table#setting-table.elevation-1(
      :headers="headers"
      :items="desserts"
      :loading='loading'
      :rows-per-page-items="rowsPerPageItems"
      :pagination.sync="pagination"
    )
      template(slot="items" slot-scope="props")
        td.text-xs-right {{ props.item.id }}
        td.text-xs-right {{ props.item.name }}

        td.justify-center.layout.px-0
          v-icon.ml-4(small="" @click="deleteItem(props.item)") delete
          v-icon.ml-4(small="" @click="editItem(props.item)") edit
          v-tooltip.v-icon.ml-4(top)
            v-icon(slot='activator' small @click="save(props.item, true)") repeat_one
            span שכפל
          router-link(tag="a" :to="'/screen/'+props.item.id" target='_blank' style="display: inline-flex; color: transparent;")
            v-icon.ml-4(small) send
      //template(slot="no-data")
          v-btn(color="primary" @click="initialize") Reset
</template>

<script>
export default {
  data: () => ({
    sort_options_system: {ASC: 'ישר', DESC: 'הפוך'},
    sort_options: [{value: 'ASC', he_value: 'ישר'}, {value: 'DESC', he_value: 'הפוך'}],
    loading: true,
    dialog: false,
    rowsPerPageItems: [10, 20, 50, 100, 1000],
    pagination: {
      rowsPerPage: 1000
    },
    headers: [
      {text: 'id', value: 'id', sortable: false, align: 'right'},
      {text: 'שם הגיליון', value: 'sheet_name', sortable: false, align: 'right'},
      {text: 'פעולות', sortable: false, align: 'right'},
    ],
    columns_style: [],
    desserts: [],
    editedItem: {
      style: {},
      meta: {search_fields: [{}]},
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'מסך חדש' : 'ערוך מסך'
    }
  },

  watch: {
    dialog(val) {
      val || this.close()
    }
  },

  created() {
    document.title = 'ScreenBuilder';

    this.$socket.on('*', (packet) => {

      let channel = packet.data[0];
      let data = packet.data[1];
      let $uniqid = data.$uniqid;
      if ($uniqid) {
        return this.$socket.res(data);
      }
      this.sockets(channel, data);
    });

    this.initialize()
    this.$emit('update:loading', false);
  },
  beforeRouteLeave(to, from, next) {
    this.$socket.off('*');
    this.$emit('update:loading', true);
    next();
  },

  methods: {
    range(first, last) {
      let a = first.charCodeAt(0)
      let b = last.charCodeAt(0) + 1
      return Array.apply(null, {length: Math.abs(b - a)})
          .map(function (x, i) {
            return String.fromCharCode(Math.min(a, b) + i)
          });
    },

    initialize() {
      this.$socket.req('sendi.screen.all', {user: this.$user}).then(data => {
        this.desserts = data.entities;
        setTimeout(() => {
          document.getElementsByClassName('v-table__overflow')[0].scrollLeft = 20000;
          this.loading = false;
        });
      });
    },

    sockets: function (channel, data) {
      let channels = {
        'sum.channel': (/*data*/) => {
          // console.log('sum.channel', data)
        }
      };
      if (!channels[channel]) {
        return console.log('Socket channel not found:', channel);
      }

      return channels[channel](data);
    },

    editItem(item) {
      // const _item = (...item);
      this.editedIndex = this.desserts.indexOf(item) || {};
      this.editedItem = Object.assign({style: {}}, item);
      this.dialog = true
    },

    deleteItem(item) {

      confirm(`בטוח? למחוק את
                    ${item.name}
                `) && this.$socket.req('sendi.screen.delete', {
        id: item.id
      }).then(() => {
        this.initialize();
      });
    },


    close() {
      this.dialog = false
    },

    save(item, duplicate = false) {
      if (duplicate && !confirm('בטוח שאתה רוצה לשכפל את המסך?')) {
        return;
      }
      if (duplicate) {
        item = {...item};
        delete item['id'];
        item['name'] = `(${item['name']})` + 'מסך חדש' + ' ' + Date.now();
      }

      this.loading = true;

      this.$socket.req('sendi.screen.editOrAdd', item).then(data => {
        let itemIdx = this.desserts.findIndex(v => v.id == data.item.id);

        if (itemIdx > -1) {
          // this.desserts[itemIdx] = data.item;
          this.initialize();
        } else {
          this.desserts.push(data.item);
        }
        this.loading = false;
        this.editedItem = {style: {}, meta: {}};
        this.editedItem.meta.search_fields = this.editedItem.meta.search_fields || [{}];
      });
      this.close();
    },

  }
}
</script>

<style lang="sass">

#setting-table .v-table__overflow
  /*height: 300px;*/
  overflow-y: auto
/*direction: rtl;*/


#setting-table .v-datatable.v-table
  direction: rtl

#setting-table .v-datatable__actions
  direction: ltr


.v-content__wrap
  background: #fff

#setting-table
  table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child)
    padding: 0 5px

.v-tooltip.v-icon span
  display: inline-flex


</style>